import { render, staticRenderFns } from "./product(old).vue?vue&type=template&id=4cb79f80&scoped=true&"
import script from "./product(old).vue?vue&type=script&lang=js&"
export * from "./product(old).vue?vue&type=script&lang=js&"
import style0 from "./product(old).vue?vue&type=style&index=0&id=4cb79f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb79f80",
  null
  
)

export default component.exports